import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { useUser } from "~/Context/userContext";
import { getArtistIsFavorite, setArtistFavorite } from "~/api/getArtist";

import axios from "react-axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarOutline } from "@fortawesome/free-regular-svg-icons";

import styled from "styled-components";

export const Wrapper = styled.span`
  display: block;
  margin: 14px 0 8px;
  text-align: left;

  button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 14px;
    border: 1px solid #c5b8d4;
    border-radius: 999px;
    background: #fff;
    color: #5c4d78;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;

    &:hover {
      border-color: #66c;
    }

    &.is-on {
      background: #f4e8ee;
      border-color: #c47a93;
      color: #8d3d58;
    }
  }
`;

const ArtistAddFavorite = (props) => {
  const { artistId = 0, artistName = "" } = props; // default Zero, artist id is undefined , not in database yet
  const { state: userState, dispatch } = useUser();

  const [isFavorite, setIsFavorite] = useState(false);
  const [artistFavId, setArtistFavId] = useState(artistId);

  useEffect(() => {
    getArtistIsFavorite(axios, artistFavId).then((result) => setIsFavorite(result.data.liked));
  }, []);

  const setFavorite = async () => {
    if (!userState.loggedin) {
      localStorage.setItem("login_artist_fav", JSON.stringify({ artistFavId, artistName }));
      dispatch({ type: "signin_open" });
      // faked since we cant set these values after login/register
      setIsFavorite(true);
      return;
    }
    setArtistFavorite(axios, artistFavId, artistName).then((result) => {
      setIsFavorite(!isFavorite);
      setArtistFavId(result.data.artistId);
    });
  };

  return (
    <span>
      <Wrapper>
        <button type="button" className={isFavorite ? "is-on" : ""} onClick={setFavorite}>
          <FontAwesomeIcon icon={isFavorite ? faStar : faStarOutline} />
          {isFavorite ? "Favorited" : "Favorite this artist"}
        </button>
      </Wrapper>
    </span>
  );
};

ArtistAddFavorite.propTypes = {
  artistId: PropTypes.number,
};

export default ArtistAddFavorite;
